export default __webpack_public_path__ + "static/international-metric-desktop-14e398ed0a6c4a05dc84d07025a02803.svg";